/* unplugin-vue-components disabled */import { render } from "./card-carousel.vue?vue&type=template&id=783e691e&scoped=true"
import script from "./card-carousel.vue?vue&type=script&lang=js"
export * from "./card-carousel.vue?vue&type=script&lang=js"

import "./card-carousel.vue?vue&type=style&index=0&id=783e691e&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-783e691e"],['__file',"src/components/cards/card-carousel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "783e691e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('783e691e', __exports__)) {
    api.reload('783e691e', __exports__)
  }
  
  module.hot.accept("./card-carousel.vue?vue&type=template&id=783e691e&scoped=true", () => {
    api.rerender('783e691e', render)
  })

}


export default __exports__